import * as ActionTypes from "../../actions";
import status from "./status";

//Updates the status apiCalls data for different api call.
var priceApiCalls = {
  postPrices: status({
    mapActionToKey: function mapActionToKey() {
      return "undefined";
    },
    types: [ActionTypes.POST_PRICES_REQUEST, ActionTypes.POST_PRICES_SUCCESS, ActionTypes.POST_PRICES_FAILURE, ActionTypes.RESET_POST_PRICES]
  }),
  collectPricesFromCafci: status({
    mapActionToKey: function mapActionToKey() {
      return "undefined";
    },
    types: [ActionTypes.COLLECTPRICESFROMCAFCI_REQUEST, ActionTypes.COLLECTPRICESFROMCAFCI_SUCCESS, ActionTypes.COLLECTPRICESFROMCAFCI_FAILURE, ActionTypes.RESET_COLLECTPRICESFROMCAFCI]
  }),
  abortCollectPricesFromCafci: status({
    mapActionToKey: function mapActionToKey() {
      return "undefined";
    },
    types: [ActionTypes.ABORTCOLLECTPRICESFROMCAFCI_REQUEST, ActionTypes.ABORTCOLLECTPRICESFROMCAFCI_SUCCESS, ActionTypes.ABORTCOLLECTPRICESFROMCAFCI_FAILURE, ActionTypes.RESET_ABORTCOLLECTPRICESFROMCAFCI]
  }),
  collectPricesFromInvertirOnline: status({
    mapActionToKey: function mapActionToKey() {
      return "undefined";
    },
    types: [ActionTypes.COLLECTPRICESFROMINVERTIRONLINE_REQUEST, ActionTypes.COLLECTPRICESFROMINVERTIRONLINE_SUCCESS, ActionTypes.COLLECTPRICESFROMINVERTIRONLINE_FAILURE, ActionTypes.RESET_COLLECTPRICESFROMINVERTIRONLINE]
  }),
  abortCollectPricesFromInvertirOnline: status({
    mapActionToKey: function mapActionToKey() {
      return "undefined";
    },
    types: [ActionTypes.ABORTCOLLECTPRICESFROMINVERTIRONLINE_REQUEST, ActionTypes.ABORTCOLLECTPRICESFROMINVERTIRONLINE_SUCCESS, ActionTypes.ABORTCOLLECTPRICESFROMINVERTIRONLINE_FAILURE, ActionTypes.RESET_ABORTCOLLECTPRICESFROMINVERTIRONLINE]
  }),
  fetchPricesByVariantInvestmentItemIdAndInstantBetweenGroupByDateFormat: status({
    mapActionToKey: function mapActionToKey(action) {
      return [action.variantInvestmentItemId, action.fromInstant, action.toInstant, action.dateFormat].join("-");
    },
    types: [ActionTypes.GET_PRICESBYVARIANTINVESTMENTITEMIDANDINSTANTBETWEENGROUPBYDATEFORMAT_REQUEST, ActionTypes.GET_PRICESBYVARIANTINVESTMENTITEMIDANDINSTANTBETWEENGROUPBYDATEFORMAT_SUCCESS, ActionTypes.GET_PRICESBYVARIANTINVESTMENTITEMIDANDINSTANTBETWEENGROUPBYDATEFORMAT_FAILURE, ActionTypes.RESET_GET_PRICESBYVARIANTINVESTMENTITEMIDANDINSTANTBETWEENGROUPBYDATEFORMAT]
  }),
  fetchPricesByInvestmentItemIdAndInstantBetweenGroupByDateFormat: status({
    mapActionToKey: function mapActionToKey() {
      return "undefined";
    },
    types: [ActionTypes.GET_PRICESBYINVESTMENTITEMIDANDINSTANTBETWEENGROUPBYDATEFORMAT_REQUEST, ActionTypes.GET_PRICESBYINVESTMENTITEMIDANDINSTANTBETWEENGROUPBYDATEFORMAT_SUCCESS, ActionTypes.GET_PRICESBYINVESTMENTITEMIDANDINSTANTBETWEENGROUPBYDATEFORMAT_FAILURE, ActionTypes.RESET_GET_PRICESBYINVESTMENTITEMIDANDINSTANTBETWEEN]
  })
};
export default priceApiCalls;